// @flow

import { fetchBookingEngineI18nQuery } from 'Views/booking/BookingEngineI18n.query';
import createAction from 'Store/utils/createAction';

export const SET_CMS = 'SET_CMS';

export const setCms = (config: CMSContent, legalInformations: LegalInformations) =>
  createAction(SET_CMS, {
    config,
    legalInformations,
  });

export const GET_BOOKING_ENGINE_I18N = 'GET_BOOKING_ENGINE_I18N';
export const getBookingEngineI18n = (appContext: AppContext) => (dispatch: ReduxDispatch) =>
  dispatch(
    createAction(
      GET_BOOKING_ENGINE_I18N,
      {},
      {
        promise: fetchBookingEngineI18nQuery(appContext),
      },
    ),
  );
